import axios from 'axios';
import { message } from 'antd';
import JSONbig from 'json-bigint';
import {
    MOCK_VIDEO_LIST,
    MOCK_PRIMARY_ACCOUNTS,
    MOCK_SUCCESS,
    MOCK_APP_INFO,
    MOCK_VIDEO_URL
} from './mockData';

// 基础 API 地址
// export const BASE_URL = 'https://wecom.wzxn.top';
export const BASE_URL = ""

// 创建 JSONbig 实例，配置为将大整数转换为字符串
const JSONbigString = JSONbig({ storeAsString: true });

// Mock Adapter Function
const mockAdapter = (config) => {
    return new Promise((resolve) => {
        const { url } = config;

        // Simulate network delay
        setTimeout(() => {
            let responseData = { code: 0, message: 'scucess', data: {} };
            let username = 'admin';

            if (url.includes('/admin/login')) {
                if (config.data) {
                    try {
                        const parsedData = JSON.parse(config.data);
                        username = parsedData.username || 'admin';
                    } catch (e) {
                         console.warn('Failed to parse login data', e);
                    }
                }
                responseData = {
                    code: 0,
                    message: '登录成功',
                    data: {
                        user_token: 'mock_token_123456',
                        user_info: {
                            username: username,
                            role: 'admin'
                        }
                    }
                };
            } else if (url.includes('/admin/logout')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/admin/edit_pass')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/admin/edit_name')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/oceanengine/get_app')) {
                responseData = MOCK_APP_INFO;
            } else if (url.includes('/ocean_engine/primary_accounts_list')) {
                responseData = MOCK_PRIMARY_ACCOUNTS;
            } else if (url.includes('/oceanengine/get_video_list')) {
                responseData = MOCK_VIDEO_LIST;
            } else if (url.includes('/oceanengine/get_video_url')) {
                responseData = MOCK_VIDEO_URL;
            } else if (url.includes('/oceanengine/cancel_audit_video')) {
                responseData = MOCK_SUCCESS;
            } else if (url.includes('/oceanengine/create_auth')) {
                responseData = {
                    code: 0,
                    message: "success",
                    data: {
                        auth_url: "https://www.example.com/mock-auth"
                    }
                };
            } else if (url.includes('/oceanengine/pre_audit_create')) { // createPreVideo
                 responseData = MOCK_SUCCESS;
            } else if (url.includes('/ai/chat')) {
                // AI 聊天 mock — 通用引导回复
                const reply = `你好！我是鹤梦云 AI 助手，有什么可以帮助你的？\n\n你可以直接输入问题，我会尽力为你解答。同时也可以尝试以下方式获得帮助：\n\n- 查看页面右上角的「更新日志」了解最新功能\n- 在左侧菜单中找到对应功能模块进行操作\n- 联系平台管理员获取更多支持`;

                responseData = {
                    code: 0,
                    message: 'success',
                    data: { reply }
                };
            } else {
                 // Default success for unknown endpoints to prevent crashing
                 responseData = MOCK_SUCCESS;
            }

            // Return a valid axios response object
            resolve({
                data: responseData,
                status: 200,
                statusText: 'OK',
                headers: {},
                config,
                request: {}
            });
        }, 500);
    });
};

// 创建 axios 实例
const service = axios.create({
    baseURL: BASE_URL,
    timeout: 5000,
    adapter: mockAdapter, // Use the mock adapter
    transformResponse: [function (data) {

        // 使用 json-bigint 解析响应数据，保留大整数精度
        if (typeof data === 'string') {
            try {
                return JSONbigString.parse(data);
            } catch (e) {
                return data;
            }
        }
        return data;
    }]
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('user_token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;

        if (res.code !== 0) {
            if (res.code === 1002) {
                message.error('登录失效，请重新登录');
                localStorage.removeItem('user_token');
                localStorage.removeItem('user_info');
                window.location.href = '/login';
            }
            return res;
        } else {
            return res;
        }
    },
    error => {
        console.log('err' + error);
        message.error(error.message);
        return Promise.reject(error);
    }
);

export default service;
